var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 122,
    viewBox: "0 0 200 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.222%",
    y1: "50%",
    x2: "100%",
    y2: "85.094%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5532",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "83.681%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.184%",
    y1: "31.625%",
    x2: "84.534%",
    y2: "56.933%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35%",
    y1: "36.902%",
    x2: "98.326%",
    y2: "61.235%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAAC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA566",
    offset: "62.951%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA76",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.571%",
    y1: "56.276%",
    x2: "78.375%",
    y2: "45.36%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3901",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.156%",
    y1: "81.179%",
    x2: "100%",
    y2: "18.821%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5532",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "73.159%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-12.2%",
    y: "-12.2%",
    width: "124.5%",
    height: "124.5%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-25.9%",
    y: "-32.8%",
    width: "151.8%",
    height: "165.5%",
    filterUnits: "objectBoundingBox",
    id: "j"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 11,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.638514404 0 0 0 0 0.294117647 0 0 0 1 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.353 7.094c-2.404 2.035-5.573 4.739-6.232 1.94-.367-1.56 1.839-3.06 3.063-4.02C34.25 3.395 33.55.694 30.929.547 21.491.019 2.723 7.337.256 21.662c-1.536 8.922 3.727 17.425 19.06 16.743 13.317-1.7 19.087-10.282 26.088-22.426 3.15-5.465 6.827-7.184 9.919-7.421 2.664-.205 3.916-3.413 1.981-5.256C54.775.89 52.085 0 49.484 0c-6.91 0-13.189 6.296-14.131 7.094",
    id: "f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.459 8.865c-7.05.008-11.095 7.397-11.673 8.25-1.256 1.856-3.69 3.504-5.548 1.657-.852-.847-.095-2.412.566-3.307 1.117-1.512-.37-3.405-2.47-3.17-10.272 1.152-22.031 10.193-19.642 21.721 1.253 6.042 9.948 13.619 24.365 7.938 9.618-4.184 10.882-12.173 12.813-21.53.868-4.21 3.177-6.16 5.453-7.031 1.963-.751 2.02-3.083.041-3.805-1.377-.503-2.67-.72-3.874-.723h-.031z",
    id: "i"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "b",
    cx: 49.022,
    cy: 82.184,
    rx: 49.022,
    ry: 49.008
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5 106.892 733.64)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.05 25.22c-3.642 0-7.102-1.76-9.254-4.708a2.887 2.887 0 0 0-2.353-1.201c-.938 0-1.796.437-2.354 1.2a11.497 11.497 0 0 1-9.254 4.708l-.203-.002C6.43 25.11 1.384 19.857 1.384 13.51V12.05c0-5.881 4.786-10.666 10.67-10.666h24.778c5.883 0 10.67 4.785 10.67 10.666v1.459c0 6.349-5.046 11.601-11.248 11.708l-.203.002z",
    fill: "url(#d)",
    transform: "rotate(1 -2511.864 4351.461)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.2,
    d: "m90.415 46.574 12.738.222-9.54 20.992-13.23-.231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.053 0C5.396 0 0 5.395 0 12.05v1.459C0 20.55 5.564 26.479 12.608 26.6a12.815 12.815 0 0 0 10.6-5.273 1.523 1.523 0 0 1 2.47 0 12.816 12.816 0 0 0 10.6 5.273c7.043-.12 12.608-6.049 12.608-13.091V12.05C48.886 5.395 43.489 0 36.832 0H12.053zM45.25 12.917v-.276c0 5.6-3.568 10.231-9.02 10.325-.06.002-.12.002-.18.002a10.11 10.11 0 0 1-8.136-4.139 4.313 4.313 0 0 0-3.47-1.77 4.314 4.314 0 0 0-3.472 1.77 10.11 10.11 0 0 1-8.316 4.137c-5.452-.094-9.02-3.858-9.02-9.457v-.592c0-5.118 3.297-9.282 8.417-9.282h24.78c5.12 0 8.417 4.164 8.417 9.282z",
    fill: "url(#e)",
    transform: "rotate(1 -2511.864 4351.461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.223 86.251-4.063-6.665a2.809 2.809 0 0 0-3.834-1.036 2.807 2.807 0 0 0-1.02 3.837l4.063 6.666a2.809 2.809 0 0 0 3.834 1.035 2.807 2.807 0 0 0 1.02-3.837zM116.578 86.251l-4.063-6.665a2.809 2.809 0 0 0-3.834-1.036 2.807 2.807 0 0 0-1.02 3.837l4.063 6.666a2.809 2.809 0 0 0 3.834 1.035 2.807 2.807 0 0 0 1.02-3.837z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 181.356 85.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFD561",
    width: 162.712,
    height: 36.854,
    rx: 18.427
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.802 0h29.666c2.275 5.904 3.413 12.047 3.413 18.427 0 6.38-1.138 12.523-3.413 18.427H32.802c-3.048-6.142-4.572-12.285-4.572-18.427 0-6.142 1.524-12.285 4.572-18.427zM95.277 0h33.009c4.295 5.904 6.442 12.047 6.442 18.427 0 6.38-2.147 12.523-6.442 18.427h-33.01c2.697-6.142 4.046-12.285 4.046-18.427 0-6.142-1.349-12.285-4.045-18.427z",
    fill: "#FFF",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "m76.867 86.424 1.6-4.93c.245-.771-.42-2.062-1.834-2.692a2.808 2.808 0 0 0-3.705 1.431l-1.181 3.912a2.807 2.807 0 0 0 1.415 3.71 2.809 2.809 0 0 0 3.705-1.43zM111.324 86.424l1.6-4.93c.244-.771-.42-2.062-1.835-2.692a2.808 2.808 0 0 0-3.704 1.431l-1.181 3.912a2.807 2.807 0 0 0 1.415 3.71 2.809 2.809 0 0 0 3.705-1.43z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.643 54.862a2.175 2.175 0 0 1-2.173 2.177c-1.2 0-2.173-.974-2.173-2.177 0-1.202.973-2.176 2.173-2.176 1.2 0 2.173.974 2.173 2.176M111.28 54.862a2.175 2.175 0 0 1-2.173 2.177c-1.2 0-2.174-.974-2.174-2.177 0-1.202.974-2.176 2.174-2.176s2.172.974 2.172 2.176",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.199 27.099)",
    fill: "url(#g)",
    opacity: 0.449
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.003 0C30.328.004 26.498 3.29 25.95 3.67c-1.19.826-3.493 1.559-5.253.737-.807-.376-.09-1.073.536-1.471 1.057-.673-.35-1.515-2.338-1.41C9.168 2.038-1.967 6.06.296 11.189c1.186 2.688 9.42 6.058 23.07 3.531 9.107-1.861 9.879-5.941 13.155-9.137.823-1.873 4.771-.565 6.926-.953 1.859-.334-.873-3.987-2.746-4.309A21.801 21.801 0 0 0 37.032 0h-.029z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.386 58.535c-3.39 0-6.137 2.753-6.137 6.149h12.274c0-3.396-2.748-6.149-6.137-6.149",
    fill: "#F4CE01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.345 68.87a4.182 4.182 0 0 0 4.178-4.186h-8.356a4.182 4.182 0 0 0 4.178 4.186",
    fill: "#F2A100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "url(#h)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#j)",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C8E1FF",
    cx: 163.402,
    cy: 33.705,
    rx: 7.839,
    ry: 7.837
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DDECFF",
    cx: 153.232,
    cy: 18.711,
    rx: 4.025,
    ry: 4.024
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPool);
export default __webpack_public_path__ + "static/media/img_pool.a22b861d.svg";
export { ForwardRef as ReactComponent };